// import Vue from 'vue'
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
// import 'element-ui/lib/theme-chalk/display.css';
// Vue.use(ElementUI);
export default {
  data() {
    return {
      showloading:null
    }
  },
  methods:{
    $$loading(){
      this.showloading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(235, 235, 237, 1)",
      });
    },
    $$closeLoading(){
      this.showloading.close();
    },
    $$success(msg){
      this.$message({
        message: msg,
        type: "success",
      })
    },
    $$info(msg){
      this.$message({
        message: msg,
        type: "info",
      })
    },
    $$error(msg){
      this.$message({
        message: msg,
        type: "error",
      })
    }
  }
} 


// WEBPACK FOOTER //
// ./src/mixins/minxin.js